// İşletme dönem aralığı (TODO-KPI-11) — çekmece alanları metin olarak tutulur ("" = sınırsız).
// Saf yardımcılar; rozet metni shared `formatEntityValidity`.

export const ENTITY_YEAR_MIN = 1990;
export const ENTITY_YEAR_MAX = 2100;

/** "" → null (sınırsız); 4 haneli yıl → sayı; aksi → undefined (geçersiz). */
export function parseEntityYearInput(s: string): number | null | undefined {
  const t = s.trim();
  if (t === "") return null;
  if (!/^\d{4}$/.test(t)) return undefined;
  const n = Number.parseInt(t, 10);
  return n >= ENTITY_YEAR_MIN && n <= ENTITY_YEAR_MAX ? n : undefined;
}

/** Taslak doğrulaması — hata metni ya da null. Sunucu da aynı kuralı doğrular (400 CLIENT_ENTITY_INVALID_RANGE). */
export function entityValidityError(fromInput: string, toInput: string): string | null {
  const from = parseEntityYearInput(fromInput);
  const to = parseEntityYearInput(toInput);
  if (from === undefined || to === undefined)
    return `Yıl ${ENTITY_YEAR_MIN}–${ENTITY_YEAR_MAX} aralığında dört haneli olmalı`;
  if (from !== null && to !== null && from > to)
    return "Başlangıç yılı bitiş yılından büyük olamaz";
  return null;
}
